
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { FlyoutLevels } from '@owc-packages/Header/src/Header.enums';
import { HeaderNavigationLinkComponent } from '@owc-packages/Header/src/HeaderNavigationLink';
import headerMixin from '@owc-utils/Mixins/Header';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as HeaderNavigationLinkComponent).extend({
  name: 'owc-header-navigation-link',
  mixins: [headerMixin, OwcDataComponent],
  components: {
    ValidationBoxWrapper,
  },
  computed: {
    navigationLink() {
      return this.componentData?.link;
    },
    legalInfo() {
      return this.componentData?.legalText;
    },
    currentFlyoutLevel() {
      if (this.componentData?.currentFlyoutLevel) {
        return this.componentData?.currentFlyoutLevel;
      }

      return FlyoutLevels.FLYOUT_LEVEL_ONE;
    },
    nextFlyoutLevel() {
      if (this.currentFlyoutLevel) {
        return this.currentFlyoutLevel + 1;
      }

      return FlyoutLevels.FLYOUT_LEVEL_THIRD;
    },
  },
  methods: {
    handleLinkClick(e: Event) {
      if (this.navigationLink) {
        const { url, label } = this.navigationLink;

        this.addAndSubmitTrackingTree(
          {
            label,
            url,
          },
          this.nextFlyoutLevel,
        );

        if (url && url.includes('#')) {
          e.preventDefault();
          this.closeHeaderFlyout(true);
          window.location.href = url;
        }
      }
    },
  },
});
